import React from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import NetmonLogo from "../../assets/images/netmon-header.png";
import NavSearch from "../NavHeader";
import Aux from "../common/Aux";
import * as actionTypes from "../../store/actions";
import AuthClient from "../../api";

const getHeaderClass = (headerBackColor, headerFixedLayout) => {
  return ["navbar", "pcoded-header", "navbar-expand-lg", headerBackColor, headerFixedLayout && "headerpos-fixed"]
    .filter(Boolean)
    .join(" ");
};

const getToggleClass = (collapseMenu) => {
  return ["mobile-menu", collapseMenu && "on"].filter(Boolean).join(" ");
};



const NavBar = ({ collapseMenu, headerBackColor, headerFixedLayout, onToggleNavigation, isFullScreen, onFullScreen }) => {
  const headerClass = getHeaderClass(headerBackColor, headerFixedLayout);
  const toggleClass = getToggleClass(collapseMenu);
  const history = useHistory();

  const handleLogout = async () => {
    const response = await AuthClient.get('/logout');
    if (response.status === 200) {
      localStorage.clear();
      history.push("/login");
    }
  };

  return (
    <Aux>
      <header className={headerClass} style={{ zIndex: 2000 }}>
        <div className="m-header">
          <a
            className={toggleClass}
            id="mobile-collapse1"
            href="#!"
            onClick={onToggleNavigation}
          >
            <span />
          </a>
          <a href="#!" className="b-brand">
            <div>
              <img src={NetmonLogo} width="60px" height="40px" alt="Netmon" />
            </div>
          </a>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <NavSearch />
            </li>
          </ul>
          <ul className="navbar-nav ml-auto">
            <li>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip style={{ pointerEvents: 'none' }} id={`tooltip-import`}>Full Screen</Tooltip>}>
                <span onClick={onFullScreen} style={{ cursor: 'pointer' }}>
                  <i className={`fa-solid fa-${(isFullScreen) ? 'compress' : 'expand'}`} />
                </span>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip style={{ pointerEvents: 'none' }} id={`tooltip-import`}>Logout</Tooltip>}>
                <span onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  <i className="fa-solid fa-right-from-bracket" />
                </span>
              </OverlayTrigger>
            </li>
          </ul>

        </div>
      </header>
    </Aux>
  );
};



const mapStateToProps = (state) => {
  return {
    rtlLayout: state.main.rtlLayout,
    headerBackColor: state.main.headerBackColor,
    headerFixedLayout: state.main.headerFixedLayout,
    collapseMenu: state.main.collapseMenu,
    isFullScreen: state.main.isFullScreen,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
    onFullScreen: () => dispatch({ type: 'FULL_SCREEN' }),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
